<div class="modal-header">
  <h2>
    Last run migration for account
    <ng-container *ngIf="migration">{{ migration.oneAccountId }}</ng-container>
  </h2>
</div>

<div class="modal-body" *ngIf="migration">
  <div class="card">
    <pre>{{ migration | json }}</pre>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cancel
  </button>
</div>
